/*
 * @Author: Kangzijuan
 * @Date: 2021-11-24 14:14:54
 * @LastEditors: Do not edit
 * @LastEditTime: 2022-02-21 19:21:24
 */
const HOME = [{
  path: '/home',
  name: 'home',
  // 按需加载路由
  component: () => import('@/views/home/HomePage'),
  // meta，具体用法请参照vue-router文档
  meta: {
    // 是否需要登录，不挂载该参数或该参数为false，表示不需要登录
    isLogin: true,
    // 是否需要鉴权，不挂载该参数或该参数为false，表示不需要鉴权
    isAuth: false,
    btnAuthList: []
  }
}]
export default HOME
